/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        17/01/2022 16:34
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import * as MenuEnum from '../enumerators/MenuEnum'
import UtilsComponent from './UtilsComponent'

export default class MenuComponent {
    trigger = '[data-hc-trigger="menu"],[data-hc-menu]'
    triggerSubmenu = '[data-hc-trigger="submenu"]'
    menuEntry = '[data-hc-id="menu-entry"]'
    menuContainer = '[data-id="maxi-menu"]'
    menuItem = '[data-id="maxi-menu-item"]'

    constructor() {
        $(this.trigger).on('click', (e) => {
            if ($('body').hasClass(MenuEnum.MENU_IS_OPEN_CLASS)) {
                this.closeMenu(e)
            } else {
                this.openMenu(e)
            }
        })
        $(this.triggerSubmenu).on('click', (e) => {
            if (
                $(e.currentTarget).parents(this.menuEntry).hasClass(MenuEnum.SUBMENU_IS_OPEN_CLASS)
            ) {
                this.closeSubmenu($(e.currentTarget).parents(this.menuEntry).get(0))
            } else {
                this.openSubmenu($(e.currentTarget).parents(this.menuEntry).get(0))
            }
        })

        if (UtilsComponent.breakpoint('desktop')) {
            $(this.menuContainer).on('click', (e) => {
                if (!$(e.target).closest(this.menuItem).length && !$(e.target).is(this.menuItem)) {
                    this.closeMenu(e)
                }
            })
        }
    }

    openMenu(e) {
        $(e.currentTarget).addClass(MenuEnum.CROSS_ACTIVE_CLASS)
        $('body').addClass(MenuEnum.MENU_IS_OPEN_CLASS)
    }

    closeMenu(e) {
        $(e.currentTarget).removeClass(MenuEnum.CROSS_ACTIVE_CLASS)
        $('body').removeClass(MenuEnum.MENU_IS_OPEN_CLASS)
        $(this.menuEntry).removeClass(MenuEnum.SUBMENU_IS_OPEN_CLASS)
    }

    openSubmenu(e) {
        $(e).addClass(MenuEnum.SUBMENU_IS_OPEN_CLASS)
    }

    closeSubmenu(e) {
        $(e).removeClass(MenuEnum.SUBMENU_IS_OPEN_CLASS)
    }
}
